import CloseIcon from "@mui/icons-material/Close"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useState } from "react"

import { yupResolver } from "@hookform/resolvers/yup"
import { Controller, FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { es } from "date-fns/locale"

import CustomTextField from "../CustomTextField"

import { Box, DialogTitle, IconButton, InputAdornment, Tooltip } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useContext, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { avanceMensualXobjetivo, editarObjetivo, limpiarAvancesXobjetivos, nuevoObjetivo, objetivosPorPGD } from "../../Redux/evaluaciones"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { UserAuth } from "../../context/AuthContext"


import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import InfoIcon from '@mui/icons-material/Info';
import CustomDateField from "../CustomDateField"
import { useParams } from "react-router-dom"
import useLider from "../hooks/useLider"


const ModalObjetivo = ({ open, handleClose, objetivo, openModalModo, evaluacionFinalizada, idPGD, isLider, competenciasLider, competenciasEvaluado, empleadosReportaA, tipoAutoevaluacion, leyenda }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const { empleado } = UserAuth()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
  const { id } = useParams();


  const setObjetivo = useSelector((store) => store.evaluaciones.setObjetivo);
  const [valuePrimerTab, setValuePrimerTab] = useState('1'); //value del tablist
  const [opcionesCompetencias, setOpcionesCompetencias] = useState([])

  const defaultValues = {
    id: null,
    objetivo: "",
    fechaDeCumplimiento: "",
    competencia: null,
    competencia2: null,
    indicador: "",
    indicador2: "",
    indicador3: "",
    indicador4: "",
    indicador5: "",
    porcentajeAvance: "",
    peso: "",
    statusSelect: null,
    estadoSelect: null,
    motivoCancelar : null,
  }

  const validacionSchema = yup.object().shape({
    objetivo: yup
      .string()
      .required("Por favor indica el objetivo.")
      .max(300, "El nombre del objetivo debe tener como máximo 300 caracteres."),
    // competencia: yup.object().required("Por favor selecciona una competencia."),
    peso: yup
      .number()
      .required("Por favor indica el valor del peso entre 10 y 100 y que sea múltiplo de 10.")
      .integer("Debe ser un número entero")
      .min(10, "Debe ser al menos 10")
      .max(100, "Debe ser como máximo 100")
      .test({
        name: 'multipleOf10',
        message: 'Debe ser un múltiplo de 10',
        test: value => value % 10 === 0,
      }),
    indicador: yup
      .string()
      .required("Por favor detalla brevemente la Acción Clave.")
      .max(200, "La Acción Clave debe tener como máximo 200 caracteres."),
    indicador2: yup
      .string()
      .nullable()
      .max(200, "La Acción Clave debe tener como máximo 200 caracteres."),
    indicador3: yup
      .string()
      .nullable()
      .max(200, "La Acción Clave debe tener como máximo 200 caracteres."),
    indicador4: yup
      .string()
      .nullable()
      .max(200, "La Acción Clave debe tener como máximo 200 caracteres."),
    indicador5: yup
      .string()
      .nullable()
      .max(200, "La Acción Clave debe tener como máximo 200 caracteres."),
    fechaDeCumplimiento: yup
      .mixed()
      .test(
        'is-date',
        'La fecha no es válida.',
        value => value && !isNaN(new Date(value).getTime())
      )
      .required("Por favor selecciona una fecha de cumplimiento.")
  });

  const { handleSubmit, setValue, reset, ...methods } = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const submitDatos = (datos) => {
    handleClose(datos, idPGD, datos.index)
    reset()
  }

  useEffect(() => {
    if (empleadosReportaA) {
      setOpcionesCompetencias(competenciasLider)
    } else {
      setOpcionesCompetencias(competenciasEvaluado)
    }
  }, [empleadosReportaA, competenciasLider, competenciasEvaluado])

  useEffect(() => {
    if (objetivo) {
      Object.keys(objetivo).forEach((key) => {
        setValue(key, objetivo[key]);
      });
    }
  }, [objetivo, setValue]);

  const cerrarModal = () => {
    handleClose()
    reset()
    setValuePrimerTab("1")
  }

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };


  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          cerrarModal();
        }
      }}
      aria-labelledby="responsive-dialog-title"
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={cerrarModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TabContext value={valuePrimerTab}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <TabList
              aria-label="scrollable force tabs example"
              onChange={handleChangePrimerTAB} variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label="Objetivo" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
              {/* El segundo Tab solo se mostrará si objetivo?.objetivo es true y tipoAutoevaluacion es igual a "Gestión y Seguimiento".  */}
              {/* {(objetivo?.objetivo && tipoAutoevaluacion === "Gestión y Seguimiento") && (
                <Tab label="Avance Mensual" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
              )} */}
            </TabList>
          </Box>
          <TabPanel value="1">
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <FormProvider {...methods}>

                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="objetivo"
                    label="Objetivo"
                    rules={{ required: "Required!" }}
                    req={true}
                    disabled={
                      evaluacionFinalizada ||
                      Boolean(objetivo?.objetivo) ||
                      !isLider ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                    startAdornment={
                      <Tooltip title={leyenda?.new_nombredeobjetivo} arrow>
                        <InputAdornment position="start">
                          <IconButton size="small">
                            <InfoIcon />
                          </IconButton>
                        </InputAdornment>
                      </Tooltip>
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
                  <CustomDateField 
                    name="fechaDeCumplimiento" 
                    label="Fecha de cumplimiento" 
                    minDate={new Date()} 
                    req={true}
                    helperText="Debe ingresar una fecha de cumplimiento válida"
                    onKeyDown={(event) => event.preventDefault()}
                    disabled = {
                      evaluacionFinalizada || 
                      Boolean(objetivo?.objetivo) || 
                      !isLider || 
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) || 
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                  />
                </Grid>
                {/* <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomSearchSelect
                    options={opcionesCompetencias}
                    req="true"
                    type="text"
                    name="competencia"
                    lab="Competencia Primaria asociada"
                    helperText="La competencia es requerida"
                    disabled={
                      Boolean(objetivo?.competencia)
                      || !isLider ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                    startAdornment={
                      <Tooltip title={leyenda?.new_competenciadeobjetivo} arrow>
                        <InputAdornment position="start">
                        <IconButton size="small" style={{ marginLeft: "5px" }}>
                            <InfoIcon />
                          </IconButton>
                        </InputAdornment>
                      </Tooltip>
                    }
                  />
                </Grid> */}
                {/* <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomSearchSelect
                    options={opcionesCompetencias}
                    type="text"
                    name="competencia2"
                    lab="Competencia Secundaria asociada"
                    helperText="La competencia es requerida"
                    disabled={Boolean(objetivo?.competencia2)||
                      !isLider ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                  />
                </Grid> */}
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    name="peso"
                    label="Peso"
                    req={true}
                    type="text"
                    disabled={
                      evaluacionFinalizada ||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                    startAdornment={
                      <Tooltip title={leyenda?.new_pesodeobjetivo} arrow>
                        <InputAdornment position="start">
                          <IconButton size="small">
                            <InfoIcon />
                          </IconButton>
                        </InputAdornment>
                      </Tooltip>
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="indicador"
                    label="Acción Clave"
                    req={true}
                    disabled={evaluacionFinalizada||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                    startAdornment={
                      <Tooltip title={leyenda?.new_resultadoclavedeobjetivo} arrow>
                        <InputAdornment position="start">
                          <IconButton size="small">
                            <InfoIcon />
                          </IconButton>
                        </InputAdornment>
                      </Tooltip>
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="indicador2"
                    label="Acción Clave 2"
                    disabled={evaluacionFinalizada ||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="indicador3"
                    label="Acción Clave 3"
                    disabled={evaluacionFinalizada ||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="indicador4"
                    label="Acción Clave 4"
                    disabled={evaluacionFinalizada ||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="indicador5"
                    label="Acción Clave 5"
                    disabled={evaluacionFinalizada ||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <CustomTextField
                    Component={TextField}
                    type="text"
                    name="porcentajeAvance"
                    label="% de Avance"
                    disabled={true}
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 3 }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={evaluacionFinalizada ||
                      setObjetivo === "LOADING" ||
                      !isLider ||
                      (objetivo.motivoCancelar && objetivo.motivoCancelar.value) ||
                      (objetivo.statusSelect && objetivo.statusSelect.value === 100000001) ||
                      tipoAutoevaluacion == "Balance y Cierre de Año"
                    }
                    onClick={handleSubmit(submitDatos)}
                  >
                    Previsualizar
                  </Button>
                </Grid>
              </FormProvider>
            </Grid>
          </TabPanel>
        </TabContext>
      </DialogContent>
    </Dialog>
  )
}

export default ModalObjetivo
